var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"options":_vm.results,"label":"ModelName","reduce":(r) => r.id},on:{"input":_vm.doSomething,"search":_vm.search},model:{value:(_vm.selectedData),callback:function ($$v) {_vm.selectedData=$$v},expression:"selectedData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }